export const phoneRegex: RegExp =
  /^(\d{10}|\+[1-9]\d{0,3}[-\s]?\(?[0-9]{2,3}\)?[-\s]?[0-9]{3,4}[-\s]?[0-9]{3,4})$/;

export const faxRegex: RegExp =
  /^(\+)?(((((\d+)|(\(\d+\))|(\(\d+\s(\d)\)))(\s|-|\d+))+)|((\d+)|(\(\d+\))$)+)+\d$/;

export const extractAllNumbers = (str: string): number => {
  if (!str) return 0;
  const matches = String(str).match(/\d+(?:\.\d+)?/g);
  return matches && matches.length > 0 ? Number(matches[0]) : 0;
};
